// Canonical schema for halvn. Loaded by instant-cli and the web app.
import { i } from '@instantdb/react';

const _schema = i.schema({
  entities: {
    $users: i.entity({
      email: i.string().unique().indexed(),
    }),
    userCompounds: i.entity({
      compoundId: i.string().indexed(),
      shortCode: i.string(),
      concentrationMgPerMl: i.number(),
      defaultDoseMg: i.number(),
      cadenceHours: i.number(),
      scheduleStartsAt: i.date(),
      currentScheduleEffectiveAt: i.string().optional(),
      scheduleHistory: i.json().optional(),
      isActive: i.boolean(),
      createdAt: i.date(),
    }),
    doses: i.entity({
      amount: i.number(),
      takenAt: i.date().indexed(),
      status: i.string().indexed(),
      createdAt: i.date(),
    }),
    mcpTokens: i.entity({
      // SHA-256 hex of the raw token. The raw token is never stored.
      tokenHash: i.string().unique().indexed(),
      // First 8 chars of the raw token, kept plaintext for UI display.
      prefix: i.string(),
      // Human label set by the user when minting.
      name: i.string(),
      createdAt: i.date().indexed(),
      // Sentinel epoch-0 means "never". Avoids optional-field gymnastics.
      lastUsedAt: i.date(),
      revokedAt: i.date(),
    }),
  },
  links: {
    userCompoundOwner: {
      forward: { on: 'userCompounds', has: 'one', label: 'owner', required: true },
      reverse: { on: '$users', has: 'many', label: 'userCompounds' },
    },
    doseUserCompound: {
      forward: { on: 'doses', has: 'one', label: 'userCompound', required: true },
      reverse: { on: 'userCompounds', has: 'many', label: 'doses' },
    },
    mcpTokenOwner: {
      forward: { on: 'mcpTokens', has: 'one', label: 'owner', required: true },
      reverse: { on: '$users', has: 'many', label: 'mcpTokens' },
    },
  },
  rooms: {},
});

type _AppSchema = typeof _schema;
interface AppSchema extends _AppSchema {}
const schema: AppSchema = _schema;

export type { AppSchema };
export default schema;
